/* eslint-disable camelcase */
import React from 'react'
import { SwiperSlide } from 'swiper/react'
import { func, object, string, bool, array } from 'prop-types'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../../utils/constants'
import Image from '../../ui/image/Image'
import AdLink from '../../ui/ad-link/AdLink'
import ResponsiveImage from '../../ui/image/ResponsiveImage'
import AdSwiper from '../../ui/ad-swiper/AdSwiper'
import SaveButton from '../../ui/button/SaveButton'
import Insights from '../Insights'

const Project = ({
  insights = EMPTY_OBJECT,
  item = EMPTY_OBJECT,
  classes,
  isBig,
  handleLinkClick,
  images = EMPTY_ARRAY,
  categories,
  gridView
}) => {
  const { url, title } = item
  const imageProject = images.length === 1 ? isBig ? images[0].url_large : images[0].url_medium : ''
  const singleImageProjectAlt = images.length === 1 ? images[0].image_alt : ''
  const saveButtonImage = images.length > 0 ? images[0].url_medium : ''

  return (
    <Insights className={`gridview__item ${classes}`} {...insights}>
      {images.length > 1 ? (
        <AdSwiper isLazy isVirtual>
          {images.map((image, index) => (
            <SwiperSlide lazy='true' key={index} virtualIndex={index}>
              <div key={index} className='gridview__image-wrapper'>
                <AdLink href={url} onClick={handleLinkClick}>
                  <ResponsiveImage
                    imageProps={{
                      large: { 'src': image.url_large },
                      medium: { 'src': image.url_medium },
                      small: { 'src': image.url_medium },
                      commonProps: {
                        className: 'swiper-lazy',
                        alt: image.image_alt || '',
                        ...(index !== 0 && { loading: 'lazy' }),
                        isBig: isBig
                      }
                    }}
                  />
                </AdLink>
              </div>
            </SwiperSlide>
          ))}
        </AdSwiper>
      )
        : (
          <div className='gridview__image-wrapper'>
            <AdLink href={url} onClick={handleLinkClick}>
              <Image src={imageProject} data-object-fit='cover' alt={singleImageProjectAlt} />
            </AdLink>
          </div>
        )
      }
      <SaveButton title={title} image={saveButtonImage} url={url} gridView={gridView} insights={insights} />
      <AdLink href={url} onClick={handleLinkClick} className='gridview__content'>
        <div className='gridview__text'>
          {/* categories */}
          {(categories && categories.length > 0 && categories.map((item, index) =>
            index < 1 && (
              <p className='gridview__entry-category' key={index}>
                {item.name}
              </p>
            )))}
        </div>
        {/* title */}
        <h3 className='gridview__entry-title'>{title}</h3>

      </AdLink>
    </Insights>
  )
}

Project.propTypes = {
  handleLinkClick: func,
  item: object,
  insights: object,
  isBig: bool,
  classes: string,
  images: array,
  categories: array,
  gridView: bool
}

export default React.memo(Project)
